import { Box, Center, Container } from "@chakra-ui/react";
import LikesAndMatchesCard from "./LikesAndMatchesCard";

/** Dedicated likes inbox — reachable from bottom nav (mobile) and header (desktop). */
export default function LikesPage() {
  return (
    <Box w="100%" minH={{ base: "calc(100dvh - 120px)", lg: "calc(100vh - 160px)" }} py={{ base: 1, md: 6 }}>
      <Container maxW={{ base: "100%", md: "container.sm" }} px={{ base: 3, md: 4 }}>
        <Center w="100%">
          <LikesAndMatchesCard variant="page" />
        </Center>
      </Container>
    </Box>
  );
}
